var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 113.75C30.35 113.75 6.25 89.65 6.25 60C6.25 30.35 30.35 6.25 60 6.25C89.65 6.25 113.75 30.35 113.75 60C113.75 89.65 89.65 113.75 60 113.75ZM60 13.75C34.5 13.75 13.75 34.5 13.75 60C13.75 85.5 34.5 106.25 60 106.25C85.5 106.25 106.25 85.5 106.25 60C106.25 34.5 85.5 13.75 60 13.75Z",
    fill: "#319E34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8992 77.9C51.8992 77.9 50.9492 77.5 50.2492 76.8L36.0992 62.65C34.6492 61.2 34.6492 58.8 36.0992 57.35C37.5492 55.9 39.9492 55.9 41.3992 57.35L52.8992 68.85L78.5992 43.15C80.0492 41.7 82.4492 41.7 83.8992 43.15C85.3492 44.6 85.3492 47 83.8992 48.45L55.5492 76.8C54.8492 77.5 53.8992 77.9 52.8992 77.9Z",
    fill: "#319E34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.6793d2c9cd01f87e7d9d12d70d7d1044.svg";
export { ForwardRef as ReactComponent };